import * as Yup from "yup";

export const FirstStepSchema = Yup.object({
  dni: Yup.number()
    .typeError("El campo DNI debe ser numérico")
    .required("El campo DNI es requerido"),
  tipoMatricula: Yup.string().required(
    "El campo Tipo de Matrícula es requerido"
  ),
  nroMatricula: Yup.number()
  .typeError('Número de matricula debe ser numérico ')
  .required('Número de matrícula es un campo requerido'),
  provincia: Yup.string().required("El campo Provincia es requerido"),
});
